module.exports = __webpack_public_path__ + "img/illustration-reset-password-dark.09ff99ac.png";